export enum GTM_CLASSES {
  GTM_ADD_LIQUIDITY_BUTTON = 'g-a-portfolio-add-liquidity',
  GTM_WITHDRAW_BUTTON = 'g-a-portfolio-withdraw',
}
